module.exports = __webpack_public_path__ + "static/pack.58df2037.svg";